import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class VoicemailService {
  private unreadCountSubject = new BehaviorSubject<number>(0);
  unreadCount$ = this.unreadCountSubject.asObservable();
  private lastRefreshAt = 0;
  private refreshInFlight = false;

  constructor(
    private http: HttpClient,
    private userService: UserService
  ) {}

  get unreadCount(): number {
    return this.unreadCountSubject.value;
  }

  refreshUnreadCount(): void {
    if (!this.userService?.id) {
      this.unreadCountSubject.next(0);
      return;
    }

    const now = Date.now();
    if (this.refreshInFlight || now - this.lastRefreshAt < 30000) {
      return;
    }

    this.refreshInFlight = true;
    this.lastRefreshAt = now;

    this.http
      .get<any>(`${environment.api_url}/voicemail/unread_count`)
      .subscribe({
        next: (resp) => {
          this.unreadCountSubject.next(Number(resp?.count || 0));
          this.refreshInFlight = false;
        },
        error: () => {
          this.unreadCountSubject.next(0);
          this.refreshInFlight = false;
        },
      });
  }

  markAsRead(messageId: number) {
    return this.http.post<any>(`${environment.api_url}/voicemail/message/${messageId}/read`, {});
  }

  markAsUnread(messageId: number) {
    return this.http.post<any>(`${environment.api_url}/voicemail/message/${messageId}/unread`, {});
  }
}
